import { render, staticRenderFns } from "./WebhookCallEventsTable.vue?vue&type=template&id=2a597644"
import script from "./WebhookCallEventsTable.vue?vue&type=script&lang=js"
export * from "./WebhookCallEventsTable.vue?vue&type=script&lang=js"
import style0 from "./WebhookCallEventsTable.vue?vue&type=style&index=0&id=2a597644&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports